import './MainContentAreaAll.css';
import { Link } from 'react-router-dom';
import React  ,{useState,setstate} from 'react'
function TCSJobComponent(props){ 
    return(
       <div className="ExperienceMainLayout">   
       <br />       
        <div class="card">  
        <div class="card-footer" style={{height:"50px"}}>
             <span className="ExperienceCardFooter-Previous"><Link onClick={() => props.handlechange('DATAINC')}>Previous</Link></span>
             <span className="ExperienceCardFooter"><Link onClick={() => props.handlechange('Infosys')}>Next</Link></span>
        </div>  
           <h5 class="card-header">
                              TCS,Pittsburgh  PA 
                              <br/>May 2021-Aug 2021
                              <br/>Full Stack.Net Developer
           </h5>
           <div class="card-body">
           <h3 style={{textDecoration:"underline"}}>Roles And Responsibilities</h3>
            -Works on old silverlight project remediation To ANGULAR 10 <br />
            -use Harmony Cli To create Component and Services and Pipe and Guard <br />
            -created  a User Control in Harmony  and use in different platform <br />
            -use Existing WCF services  and migrated to json using Appige platform and use in application<br /> 
            -use Soap UI to Test Services And also Modified services <br />
            -also work on sql server for modification of sql queries and procedure according to business  Changes<br /> 
            -Working on old wcf services and use appige for convert xml to json and json to xml <br />
            -use angular  material thing in project to create user interface <br />
            -work on silver light module architecture and convert that  module  in angular component <br />
            -work on inhouse framework like harmony and angular schematics<br />
            -widely using angular material in ui creation <br />
            -created a user control and used in main angular driver app<br />
            -create custom  directive  and pipe for transforming data <br />
            -created custom validator classes and implemented services and router guard according customer requirement<br /> 
            -handling project repository and make pipeline from azure to deployment server for cicd <br />
            -used angular schematics kind architecture for project development <br />
            -work on database  for return json object to make class object in angular project and also Use That object Data For -Unit Testing In Angular <br />
            -Used Bitwise Enum In Angular App  To Set Boolean Flag Value for Application User <br /> 
           <h3 style={{textDecoration:"underline"}}>Environment</h3>
           Microsoft Visual Studio 2013, ASP.NET, C#, XML, JSON, JavaScript, jQuery, Agile and Scrum, Team Foundation Server 2010,Bit Bucket , Git For  Windows  ,Windows Server 2008 R2/2008 2010             
           </div>            
           
       </div>
       </div>   
    )
}
export default TCSJobComponent